/* eslint-disable */
export default {
  copy: 'Copy',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
